const ACCESS_STATUS = {
  UNKNOWN: 10,
  REMOVED: 20,
  LOCKED: 25,
  LEGACY: 30,
  UPLOADED: 40,
  ADDED_VIA_ADMIN: 50,
};

export default ACCESS_STATUS;
